import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;

// Conecta ao Reverb sob demanda, e não em toda página (o host hoje é um IP
// privado, e o browser pede permissão de "acessar dispositivos na rede local"
// assim que a conexão é aberta). Só quem realmente usa o chat (Atendimento)
// deve chamar initEcho() antes de usar window.Echo.
export function initEcho() {
    if (window.Echo) {
        return window.Echo;
    }

    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(row => row.startsWith('XSRF-TOKEN' + '='));

    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: process.env.MIX_REVERB_APP_KEY,
        wsHost: process.env.MIX_REVERB_HOST,
        wsPort: process.env.MIX_REVERB_PORT ?? 80,
        wssPort: process.env.MIX_REVERB_PORT ?? 443,
        forceTLS: (process.env.MIX_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: '/broadcasting/auth',
        withCredentials: true,
        auth: {
            headers: {
                // O Laravel irá automaticamente enviar o cookie de sessão se estiver configurado corretamente
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'X-XSRF-TOKEN':  cookie.replace(['XSRF-TOKEN=', '%3D'], '')
            }
        }
    });

    return window.Echo;
}



// WEBPACK FOOTER //
// ./resources/assets/js/echo.js